import React, { useEffect, useRef, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { DocumentUrl } from "../../models/cartable.model";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import FolderZipOutlinedIcon from "@mui/icons-material/FolderZipOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { Button, Grid } from "@mui/material";
import ModalCancel from "../modals/ModalCancel";

export default function LoadDocumentCmp(props: any) {
  const spanRef = useRef<HTMLSpanElement>(null);
  const [textWidth, setTextWidth] = useState(0);
  const [widthDiv, setWidthDiv] = useState<any>(0);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const reference = React.useRef(null);
  const [dimensions, setDimensions] = useState<any>({ width: 0, height: 0 });
  const queryClient = useQueryClient();
  useEffect(() => {
    if (reference.current) {
      setDimensions({
        width: reference?.current,
        height: reference.current,
      });
    }
    setWidthDiv(dimensions.width.offsetWidth);
  }, [textWidth]);
  let classText: any;
  if (textWidth + 20 > widthDiv) {
    classText = "paraghramImage infoText";
  }

  const getTextWidthInPixels = (ref: HTMLSpanElement) =>
    ref != null ? ref.getBoundingClientRect().width : 0;

  useEffect(() => {
    setTextWidth(getTextWidthInPixels(spanRef.current!));
  }, [spanRef]);

  let isValue;
  if ((props.title == true && props.data) || props?.data?.fileType! === "PDF") {
    isValue = true;
  } else if (props.title == false && props.data) {
    isValue = false;
  }
  let typeFiles;
  let type;
  if (props?.data?.fileType! === "Image") {
    typeFiles = <img src={props.data.fileUrl} className="uploadImage" />;
    type = "jpg";
  } else if (props?.data?.fileType! == "PDF") {
    typeFiles = (
      <PictureAsPdfOutlinedIcon
        className={
          props.parentPage == "furtherInfo"
            ? "uploadImageCmpIconPDF"
            : "uploadImageCmpIconPDFfurtherInfo "
        }
        // style={{ marginTop: "1vh" }}
      />
    );
    type = "pdf";
  } else if (
    props?.data?.fileType! === "ZIP" ||
    props?.data?.fileType! === "RAR"
  ) {
    typeFiles = <FolderZipOutlinedIcon className="uploadImageCmpIcon " />;
    type = "RAR";
  } else {
    typeFiles = <InsertDriveFileOutlinedIcon className="uploadImageCmpIcon " />;
    type = "jpg";
  }
  const openModalDeleteImage = () => {
    setOpenModal(!openModal);
  };
  const deleteDocument = useMutation(props.serviceName, {
    onSuccess: async (data: boolean) => {
      if (data) {
        if (props.cacheName != undefined) {
          let supplierAttachments = queryClient.getQueryData<DocumentUrl[]>(
            props.cacheName
          );
          supplierAttachments?.map((item: any) => {
            if (item.fileId === props.data.fileId) {
              item.fileUrl = undefined;
              return;
            }
          });
          queryClient.setQueryData(props.cacheName, supplierAttachments);
          props.setChildValue(queryClient.getQueryData(props.cacheName));
        } else if (
          props.attachments !== undefined &&
          props.attachments.length > 0
        ) {
          let attachmentsTemprory = props.attachments?.filter(
            (x: { fileId: any }) => x.fileId != props.data.fileId
          );
          props.setChildValue(attachmentsTemprory);
        } else {
          props.setChildValue(undefined);
        }
      }
    },
    onError: (err) => {},
  });

  const deleteImage = () => {
    if (props.serviceRequestObj !== undefined) {
      deleteDocument.mutate(props.serviceRequestObj);
    } else if (props.multiItem !== undefined && props.multiItem) {
      let supplierAttachments = props.attachments?.filter(
        (item: any) => item.fileUrl !== props.data.fileUrl
      );

      props.setChildValue(supplierAttachments);
    } else {
      props.setChildValue(undefined);
    }
  };
  const handleOpenImage = () => {
    if (props.data?.fileUrl!) {
      // ساخت یک Blob برای داده‌های Base64
      const base64Data = props.data?.fileUrl!.split(",")[1];
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "image/png" });
      const url = URL.createObjectURL(blob);

      // باز کردن در تب جدید
      window.open(url, "_blank");

      // آزادسازی حافظه
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
    if (props.document!) {
      // ساخت یک Blob برای داده‌های Base64
      let document = "data:image/png;base64," + props.document;
      const base64Data = document!.split(",")[1];
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      // ایجاد فایل Blob و نمایش در تب جدید
      const blob = new Blob([byteNumbers], { type: "image/png" });
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");

      setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
  };
  return (
    <div
      className={props.className ? props.className : "UploadImageCmp"}
      style={{
        height: props.height ? props.height : "",
      }}
    >
      <>
        {isValue ? (
          <>
            {props.picName !== "storePic" && (
              <a
                href={`${props.data.fileUrl!}/true`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {typeFiles}
              </a>
            )}
            {
              <div
                className="row rowUploadImage"
                style={props.data.createDate_Persian ? { height: "38%" } : {}}
              >
                <div
                  className="col-12 cont"
                  style={{ color: "#fff" }}
                  ref={reference}
                >
                  <p
                    className={classText ? classText : "paraghramImage"}
                    style={{ marginTop: "0.9vh" }}
                  >
                    <span
                      ref={spanRef}
                      contentEditable
                      suppressContentEditableWarning
                      onInput={() =>
                        setTextWidth(getTextWidthInPixels(spanRef.current!))
                      }
                    >
                      {props.data.documentTypeTitle}
                    </span>
                    {props.data.createDate_Persian && (
                      <>
                        <br />
                        <span> {props.data.createDate_Persian}</span>
                      </>
                    )}
                  </p>
                </div>
              </div>
            }
          </>
        ) : (
          <>
            <a
              onClick={
                props.picName === "storePic" ? handleOpenImage : undefined
              }
              href={
                props.picName !== "storePic"
                  ? `${props?.data?.fileUrl!}/true`
                  : undefined
              }
              target="_blank"
              rel="noopener noreferrer"
              style={{
                height: props.height ? props.height : "",
                display: props.display ? props.display : "",
              }}
            >
              {props.document ? (
                <img
                  src={`data:image/png;base64,${props.document}`}
                  className={
                    props.className2
                      ? props.className2
                      : "uploadImage verticalImageloadDocument "
                  }
                  alt=""
                />
              ) : (
                <img
                  src={props?.data?.fileUrl!}
                  className={
                    props.className2
                      ? props.className2
                      : "uploadImage verticalImageloadDocument "
                  }
                  alt=""
                />
              )}
            </a>
            {props.deleteIcon ? (
              <Grid
                container
                style={{
                  position: props.position ? props.position : undefined,
                  bottom: props.bottom ? props.bottom : undefined,
                  left: props.left ? props.left : undefined,
                  margin: props.margin ? props.margin : undefined,
                  textAlign: "left",
                }}
              >
                <Grid item xs={12}>
                  <Button
                    style={{
                      backgroundColor: "#34495E",
                      zIndex: "1",
                      position: "relative",
                      borderRadius: "50%",
                      width: "4vh",
                      minWidth: " 4vh",
                      height: "4vh",
                      textAlign: "center",
                      alignContent: "center",
                    }}
                    onClick={openModalDeleteImage}
                  >
                    <DeleteOutlineOutlinedIcon style={{ color: "#fff" }} />
                  </Button>
                </Grid>
              </Grid>
            ) : (
              ""
            )}
          </>
        )}
      </>
      {openModal === true ? (
        <ModalCancel
          title={""}
          bgColor={"kamanColor"}
          setValue={deleteImage}
          openModal={openModal}
          setOpenModal={setOpenModal}
        />
      ) : (
        ""
      )}
    </div>
  );
}
